<template>
  <div id="import-file" class="q-pa-md">
    <div class="crud-title"><translate>PROCESSING_DATA_SAMAE</translate></div>
    <crud ref="crudLayout" :name="name" :id="id"> </crud>
    <pageExportFile ref="pageExportFile" />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import SamaeController from './SamaeController'
import { JtCrud } from 'jtech-webcomps'
import pageStart from './page/PageStart'
import pageFile from './page/PageFile'
import pageAnalyze from './page/PageAnalyze'
import pageShutdown from './page/PageShutdown'
import pageExportFile from './page/PageExportFile'

const { CrudLayout } = JtCrud

@Component({
  name: 'ImportFile',
  components: {
    pageExportFile,
    crud: CrudLayout
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ImportFile extends Vue {
  controller = SamaeController.getInstance();

  async mounted () {
    this.onButton()
    await this.addPageImportFile()
    this.$refs.crudLayout.setPage('import')
  }

  onButton () {
    this.$refs.crudLayout.onButton('btProcessar', this.btProcessar)
    this.$refs.crudLayout.onButton('btExportar', this.btExportar)
    this.$refs.crudLayout.onButton('icAlterar', this.icAlterar)
    this.$refs.crudLayout.onButton('icAlterarUnit', this.icAlterarUnit)
    this.$refs.crudLayout.onButton('icGerarDocumento', this.icGerarDocumento)
    this.$refs.crudLayout.onButton('icFindFile', this.icFindFile)
    this.$refs.crudLayout.onButton('icFinancialProcess', this.icFinancialProcess)
    this.$refs.crudLayout.onButton('icBaixarDocumento', this.icBaixarDocumento)
    this.$refs.crudLayout.onButton('icResponsavelUnit', this.icResponsavelUnit)
    this.$refs.crudLayout.onButton('btAnalisar', this.btAnalisar)
    this.$refs.crudLayout.onButton('btAnalisarShutdown', this.btAnalisarShutdown)
    this.$refs.crudLayout.onButton('unitStateSamaeUnitNewAssociate', this.unitStateSamaeUnitNewAssociate)
  }

  async unitStateSamaeUnitNewAssociate ({ button, params, page }) {
    await this.controller.unitStateSamaeUnitNewAssociate(params)
    if (!params.companyCodeWater) {
      this.$refs.crudLayout.removePage(page)
      this.$refs.crudLayout.setPage('import')
    }
  }

  async btAnalisar ({ button, params, page }) {
    const form = page.forms[2][0]
    if (form.nmInterface == 'consumerUnit.gravar') {
      await Vue.prototype.$jt.repository.create(form.nmInterface, form.dadosForm)
    } else {
      await Vue.prototype.$jt.repository.update(form.nmInterface, { ...form.dadosForm, id: form.dadosForm.consumerUnitId })
    }
    await this.controller.unitStateSamaeUnitNew({
      ...params
    })
    this.$refs.crudLayout.removePage(page)
    this.$refs.crudLayout.setPage('import')
  }

  async btAnalisarShutdown ({ button, params, page }) {
    const form = page.forms[2][0]
    const dadosFormUnitDisabled = page.forms[0].dadosForm
    await Vue.prototype.$jt.repository.update(form.nmInterface, { ...form.dadosForm, id: form.dadosForm.consumerUnitId })
    await this.controller.unitStateSamaeUnitDisabled({
      ...dadosFormUnitDisabled, consumerUnit: form.dadosForm.consumerUnitId, unitStateSamae: params.id
    })
    this.$refs.crudLayout.removePage(page)
    this.$refs.crudLayout.setPage('import')
  }

  icResponsavelUnit ({ button, params, page }) {
    this.$q
      .dialog({
        title: this.$gettext('CONFIRMATION'),
        message: this.$gettext(
          'THIS_RECORD_WILL_BE_ASSOCIATED_WITH_YOU'
        ),
        ok: this.$gettext('YES'),
        cancel: this.$gettext('CANCEL'),
        preventClose: true
      })
      .onOk(async () => {
        await this.controller.joinUnit({ id: params.id })
        page.$refs.jtDataTable.refresh()
      })
  }

  async icAlterarUnit ({ button, params, page }) {
    const actions = {
      50230002: async () => {
        const formDetail = await this.controller.unitStateSamaeDetail({ id: params.id })
        const form = await this.controller.analyze({ id: params.id })

        this.$refs.crudLayout.addPage({
          type: 'table',
          label: this.$gettext('ANALYZE_CONVAG') + ' - ' + params.convag,
          params: this.$refs.crudLayout.__loadParamsRouter({}),
          component: pageAnalyze,
          flClose: true,
          forms: [...formDetail, ...form],
          parent: this
        })
      },
      50230001: async () => {
        await this.controller.unitStateSamaeClientChange({ ...params })
        page.$refs.crudLayoutSearch.refresh()
      },
      50230003: async () => {
        await this.unitStateSamaeUnitDisabled({ button, params, page })
      },
      50230004: async () => {
        await this.unitStateSamaeUnitDisabled({ button, params, page })
      }
    }

    const chCodigo = params.unitStateSamae.find((r) => r.chCodigo).chCodigo
    if (chCodigo && actions[chCodigo]) {
      await actions[chCodigo]()
    }
  }

  async unitStateSamaeUnitDisabled ({ button, params, page }) {
    const formDetail = await this.controller.unitStateSamaeDetail({ id: params.id })
    const form = await this.controller.analyze({ id: params.id })

    this.$refs.crudLayout.addPage({
      type: 'table',
      label: this.$gettext('ANALYZE_CONVAG') + ' - ' + params.convag,
      params: this.$refs.crudLayout.__loadParamsRouter({}),
      component: pageShutdown,
      flClose: true,
      forms: [...formDetail, ...form],
      parent: this
    })
  }

  async addPageImportFile () {
    const { forms, datatable } = await this.controller.importFile()
    if (this.$refs.crudLayout.$refs.containerRef.container.pages.length === 0) {
      this.$refs.crudLayout.addPage({
        type: 'form',
        name: 'import',
        label: this.$gettext('IMPORT_DATA'),
        labelPage: this.$gettext('IMPORT_DATA'),
        params: this.$refs.crudLayout.__loadParamsRouter({}),
        component: pageStart,
        flClose: false,
        forms: forms,
        datatable: datatable,
        parent: this
      })
    }
  }

  icAlterar ({ button, params, page, controller }) {
    const label = `Arquivo: ${params.createdAt.substring(0, 2)}/${params.createdAt.substring(3, 5)}/${params.createdAt.substring(6, 10)}[${params.id}]`

    this.$refs.crudLayout.addPage({
      type: 'table',
      label: label,
      params: { ...params, label },
      component: pageFile,
      flClose: true,
      parent: this
    })
  }

  async btProcessar ({ button, params, page, controller }) {
    const forms = await this.controller.processFile(params)
  }

  async icGerarDocumento ({ button, params, page, controller }) {
    await this.controller.icGerarDocumento({ ...params })
    this.refreshJtDataTable(page, 0)
  }

  async icFindFile ({ button, params, page, controller }) {
    this.$refs.pageExportFile.show({ button, params, page, controller })
  }

  async icFinancialProcess ({ button, params, page, controller }) {
    await this.controller.icFinancialProcess({ ...params })
    this.refreshJtDataTable(page, 0)
  }

  refreshJtDataTable (page, index) {
    page.$refs.jtDataTable.refresh()
    setTimeout(() => {
      if (index < 10) {
        this.refreshJtDataTable(page, index++)
      }
    }, 30000)
  }

  async icBaixarDocumento ({ button, params, page, controller }) {
    const nameFile = params.exportFileSamaeFile
    const blob = await this.controller.processExportFile(nameFile)
    const fileLink = document.createElement('a')
    const fileURL = window.URL.createObjectURL(blob.data, { type: 'text/plain' })
    fileLink.href = fileURL
    fileLink.setAttribute('download', nameFile)
    document.body.appendChild(fileLink)
    fileLink.click()
    document.body.removeChild(fileLink)
  }
}
export default ImportFile
</script>
<style lang="stylus"></style>
